import React from 'react';
import { Link } from 'react-scroll';
import { FaTwitter } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { HiOutlineMail } from 'react-icons/hi';

const Footer = () => {
    return (
        <div className="bg-[#070716] w-full text-white">
            <footer className="text-center border-t p-10">
                <div className="flex items-center justify-center">
                    <Link to='about' className="cursor-pointer">About</Link>
                    <Link to='works' className="cursor-pointer mx-4">Works</Link>
                    <Link to='skills' className="cursor-pointer">Skills</Link>
                    <Link to='contact' className="cursor-pointer ml-4">Contact</Link>
                </div>
                <div>
                    <div className="flex items-center justify-center my-6">
                        <a href="https://twitter.com/saad_shafkat"><FaTwitter size={25} /></a>
                        <a href="mailto:shafkatsaad@gmail.com"><HiOutlineMail size={30} className='mx-4' /></a>
                        <a href="tel: 01521567825"><FiPhoneCall size={23} /></a>
                    </div>
                </div>
                <div>
                    <p>Copyright © 2026 - All right reserved by <span className='font-bold'>Shafkat Alam Saad</span></p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;